import { gql } from '@apollo/client/core';

export const CONSUME_INVITED_SITTER_TOKEN_MUTATION = gql`
  mutation ConsumeInvitedSitterToken($interviewRequestId: UUID!, $invitedSitterToken: String!, $invitedSitterId: UUID!) {
    request {
      consumeInvitedSitterToken(
        interviewRequestId: $interviewRequestId
        invitedSitterToken: $invitedSitterToken
        invitedSitterId: $invitedSitterId
      )
    }
  }
`;

export const CREATE_INTERVIEW_REQUEST = gql`
  mutation CreateInterviewRequest(
    $scCareSessionId: Int
    $start: DateTime!
    $end: DateTime!
    $location: LocationInput!
    $details: String!
    $interviewRequestKind: InterviewRequestKind!
    $invitedSitter: InvitedSitterInput
    $sitter: SitterAccountInput
    $invitedSitterBusinessInfo: InvitedSitterBusinessInfoInput
  ) {
    createInterviewRequest(
      scCareSessionId: $scCareSessionId
      start: $start
      end: $end
      location: $location
      details: $details
      interviewRequestKind: $interviewRequestKind
      invitedSitter: $invitedSitter
      sitter: $sitter
      invitedSitterBusinessInfo: $invitedSitterBusinessInfo
    ) {
      id
    }
  }
`;

export const CONFIRM_SC_CARE_SESSION = gql`
  mutation ConfirmScCareSession($contractUuid: UUID!) {
    corp {
      backupCare {
        confirmScCareSession(contractUuid: $contractUuid)
      }
    }
  }
`;

export const DECLINE_SC_CARE_SESSION = gql`
  mutation DeclineScCareSession($contractUuid: UUID!) {
    corp {
      backupCare {
        declineScCareSession(contractUuid: $contractUuid)
      }
    }
  }
`;
